import Resources from '../../../helpers/resources';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorActions from '../../app/errors/errors-actions';
import {
    ENDPOINT_PATH_ACTIVITY_MASTERY,
    ENDPOINT_PATH_ALL_YEARS,
    ENDPOINT_PATH_ALL_TEACHERS
} from '../../../helpers/constants';
import {
    ALL_TEACHERS,
    ALL_YEARS
} from '../../../components/report-filters/filter-constants';

export const ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED =
    'ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED';

function getActivityMasteryData(
    selectedDate,
    selectedYearGroupId,
    selectedTeacherId
) {
    return (dispatch, getState) => {
        const state = getState();
        if (state.isAdmin === true) {
            getAdminData(
                dispatch,
                selectedDate,
                selectedYearGroupId,
                selectedTeacherId
            );
        } else {
            getTeacherData(dispatch, selectedDate);
        }
    };
}

function getAdminData(
    dispatch,
    selectedDate,
    selectedYearGroupId,
    selectedTeacherId
) {
    let yearGroupId = ENDPOINT_PATH_ALL_YEARS;
    let teacherId = ENDPOINT_PATH_ALL_TEACHERS;
    let resource = 'yearGroupReport';

    if (selectedYearGroupId != null && selectedYearGroupId !== ALL_YEARS) {
        yearGroupId = selectedYearGroupId;
    }
    if (selectedTeacherId != null && selectedTeacherId !== ALL_TEACHERS) {
        teacherId = selectedTeacherId;
        resource = 'teacherReport';
    }

    const params = {
        reportType: ENDPOINT_PATH_ACTIVITY_MASTERY,
        ...DateParamHelper.getDateTypePath(selectedDate),
        yearGroupId,
        teacherId
    };
    getData(resource, dispatch, selectedDate, params);
}

function getTeacherData(dispatch, selectedDate) {
    getData('allClassesReport', dispatch, selectedDate);
}

function getData(resource, dispatch, selectedDate, params = {}) {
    params = {
        reportType: ENDPOINT_PATH_ACTIVITY_MASTERY,
        ...DateParamHelper.getDateTypePath(selectedDate),
        ...params
    };
    Resources[resource]
        .get(params)
        .withParams(DateParamHelper.getDateQueryParams(selectedDate))
        .send()
        .then((payload) => {
            if (payload.valid) {
                dispatch({
                    type: ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED,
                    payload: mapActivityMasteryData(payload.data)
                });
            } else {
                dispatch(
                    errorActions.addError(
                        ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED
                    )
                );
            }
        });
}

function mapActivityMasteryData(data) {
    const { allClassroomActivityMasterys: allClassesData } = data;

    let allClassesActivityMastery;
    let classroomActivityMasterys;
    if (allClassesData) {
        allClassesActivityMastery = {
            scoreBand: {
                mastered: allClassesData.allMasteredScores,
                consolidating: allClassesData.allConsolidatingScores,
                developing: allClassesData.allDevelopingScores,
                emerging: allClassesData.allEmergingScores,
                needsImproving: allClassesData.allNeedsImprovingScores
            },
            goldBars: allClassesData.allGoldbars,
            totalActivities: allClassesData.allTotalActivities
        };
        classroomActivityMasterys = allClassesData.classroomActivityMasterys;
    } else {
        allClassesActivityMastery = {};
        classroomActivityMasterys = [];
    }

    return {
        allClassesActivityMastery,
        classroomActivityMasterys,
        courseStrengths: mapStrengthWeakness(data.courseStrengths),
        courseWeaknesses: mapStrengthWeakness(data.courseWeaknesses, false)
    };
}

function mapStrengthWeakness(strengthWeakness, descending = true) {
    const defaultData = {
        id: 0,
        classroomName: '-',
        title: '-',
        averageResult: '- '
    };

    if (!strengthWeakness || strengthWeakness.length === 0) {
        return [defaultData];
    }

    if (descending) {
        strengthWeakness = strengthWeakness.sort(
            (a, b) => a.averageResult < b.averageResult
        );
    } else {
        strengthWeakness = strengthWeakness.sort(
            (a, b) => a.averageResult > b.averageResult
        );
    }

    return strengthWeakness.map((item, idx) => ({
        ...item,
        id: idx
    }));
}
export default {
    getActivityMasteryData
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/all-classes/all-classes-actions.js